function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var check = {
  "id": "check",
  "symbol": "<symbol id=\"check\" viewBox=\"0 0 23 17\" style=\"fill: currentColor\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.4142 3.41388L9.50003 16.3281L0.585815 7.41388L3.41424 4.58545L9.50003 10.6712L19.5858 0.585449L22.4142 3.41388Z\" /></symbol>"
};

export { check };
